/**
 * This is where we define the data structure for all the data we receive from backend e.g. User, Project, Device, etc...
 */
// The Key we will add to the REQUEST header when we make API call to AppAPI to pass user's auth token to the backend
export const AUTHORIZATION_KEY = 'Authorization';
// The Prefix that we will add to the auth token when we add the auth token to the REQUEST header.
export const AUTHORIZATION_KEY_PREFIX = 'ModeCloud';
